import { cn } from '@/platform/lib/utils';

const ModalContent = ({ className, children, ...props }) => (
    <div className={cn(className)} {...props}>
        {children}
    </div>
);

export default ModalContent;
